import { FormFieldValue } from '../types';
import { FormFieldValidator } from './FormFieldValidator';

export class TextFormFieldValidator extends FormFieldValidator {
  protected isValid(value: FormFieldValue) {
    return this.isEmpty(value)
      ? this.requiredCheck(value)
      : this.requiredCheck(value) && this.lengthCheck(value);
  }

  protected lengthCheck(value: FormFieldValue): boolean {
    let result;
    result = this.minLength !== null ? value.length >= this.minLength : true;
    result = result && this.maxLength !== null ? value.length <= this.maxLength : result;
    return result;
  }
}
